import type {NextPage} from 'next';
import Image from 'next/image';
import {useState} from 'react';
import PadhaaiImage from '../images/home/padhaai-img.png';
import HomeTab from '../components/HomeTab';
// import SideBar from '../components/SideBar';


const Home: NextPage = () => {
	return (
		<>
			<HomeTab />
			<style global jsx>{`
				footer {
					display: none !important;
				}
				.active {
					color: #f9c933;
				}
			`}</style>
			<div className='sm:hidden'>{/* <SideBar activePage={""} scholarship={{}} /> */}</div>
		</>
	);
};

export default Home;
